// the input needs to be synced with scss variables (transition-delay, duration) in the different animations files.
// when element enters it will wait for the previous element to partially exist before starting the transition.
// this timeout effect the time gaps between classNames changes that react-transition-group applies on the elements
export function getCoupledAnimationTimeouts(transitionDuration, enterTransitionDelay) {
    return {
        exit: transitionDuration,
        enter: transitionDuration * 2 - enterTransitionDelay,
    };
}
//# sourceMappingURL=helpers.js.map